import { rootApi } from 'root-api'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    createBookingCode: build.mutation({
      query: (data) => ({
        url: '/api/booking_codes',
        method: 'POST',
        data
      }),
      invalidatesTags: ['BOOKING_CODES']
    }),
    getBookingCodes: build.query({
      query: ({ eventTypeUuid, count = 20, pageToken }) => ({
        url: '/api/booking_codes',
        method: 'GET',
        params: {
          event_type_uuid: eventTypeUuid,
          count,
          ...(pageToken && { page_token: pageToken })
        }
      }),
      providesTags: ['BOOKING_CODES']
    }),
    deleteBookingCode: build.mutation({
      query: (uuid) => ({
        url: `/api/booking_codes/${uuid}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['BOOKING_CODES']
    }),
    updateBookingCode: build.mutation({
      query: ({ uuid, data }) => ({
        url: `/api/booking_codes/${uuid}`,
        method: 'PATCH',
        data
      }),
      invalidatesTags: ['BOOKING_CODES']
    })
  })
})

export const {
  useCreateBookingCodeMutation,
  useGetBookingCodesQuery,
  useDeleteBookingCodeMutation,
  useUpdateBookingCodeMutation
} = api
